module.exports = " <div id=\"splash-container\">\r\n   <div id='renovo-wrap'>\r\n     <div id=\"renovo\"></div>\r\n   </div>\r\n</div>\r\n"